import React from 'react';
import { useAdminApproval } from './AdminApprovalProvider';
import { Box, Typography, Alert } from '@mui/material';

export const UserDashboard: React.FC = () => {
  const { isApproved } = useAdminApproval();
  
  // Note: Registered users now get 10 API calls per day that reset automatically at midnight
  // We no longer reset the count when they log in since they have their own daily limit

  if (!isApproved) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Alert severity="info" sx={{ mb: 2 }}>
          <Typography variant="h5" gutterBottom>
            Account Pending Approval
          </Typography>
          <Typography variant="body1">
            Your account is pending admin approval. Please check back later or contact support if you believe this is an error.
          </Typography>
        </Alert>
      </Box>
    );
  }

  // For approved users, just show a brief welcome - the Chat component will be shown by the parent
  return (
    <Box sx={{ mb: 2 }}>
      {/* Welcome message removed */}
    </Box>
  );
}; 